// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3oZBw","selected":"Chip_selected__2Xvdr"};